import React, { useState, useEffect, useRef, useReducer } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from "react-router-dom";
import * as ideWrapper from "../../lms-shared/ide-wrapper";
import ProjectActionPopup from './ProjectActionPopup'
import Popup from "./Popup";
import { lessonsApi, participantsApi, projectsApi } from '../../../utils'
import classes from './Project.module.css'
import Header from '../../Header/Header'
import Moment from 'moment';
import { useNavigate } from 'react-router-dom';
import projectIcon from '../../../assests/project/white-project-icon.png'
import goBbackIcon from '../../../assests/project/go-back--dark-icon.png'
import shareIcon from '../../../assests//project/share.png'
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { ObjectTypeEnum, ObjectTypeEnumText } from "../../../models/ObjectTypeEnum";
import PostPopUp from "../Dashboard/Friends/Share/PostPopUp";
import { ParticipantTypeEnumText } from "../../../models/ParticipantTypeEnum";
import SendLink from "../../lms-shared/UI/SendLink";
import SaveTimer from "../../lms-shared/UI/Timer/SaveTimer";
import { onKeyDown } from "../../../service";
import SubmitBtn from "../../lms-shared/SubmitBtn/SubmitBtn";
import * as submissionStatus from '../../../models/SubmissionStatus'
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";
import { sendControlRequest, sendMessageToTeam, updateMessageProperty, updateReadenMessage } from "../../lms-shared/store/signalRMessages-actions";
import { ControlRequestTypeEnum } from "../../lms-shared/models/ControlRequestTypeEnum";

const versionsReducer = (versions, action) => {
    switch (action.type) {
        case 'INIT':
            return action.versions
        case 'ADD':
            return [{ ...action.newVersion, isCurrent: true }, ...versions?.map(v => ({ ...v, isCurrent: false }))]
        case 'SET_CURRENT':
            return versions.map(v => ({ ...v, isCurrent: action.id === v.id }))
        default:
    }
}


const Project = () => {
    const iframeRef = useRef();
    const { projectId } = useParams();
    const { direction, texts, lang } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);
    const { homeUrl, applicationId, hideSubmitProjectBtn } = useSelector(state => state.application);
    const studyGroup = useSelector(state => state.topics.studyGroup);
    const [showProjectActionPopup, setShowProjectActionPopup] = useState(false)
    const [sharedProject, setSharedProject] = useState(false)
    const [beenSharedBefore, setBeenSharedBefore] = useState(false)
    const [versions, dispatch] = useReducer(versionsReducer, []);
    const [projectData, setProjectData] = useState({})
    const [friendsData, setFriendsData] = useState()
    const [message, setMessage] = useState(null)
    const [finish, setFinish] = useState(false)
    const [timerMinutes, setTimerMinutes] = useState(uiData.lastSave)
    const { state } = useLocation()
    const [sentRequest, setSentReqest] = useState(false)
    const timeoutRef = useRef(null);
    const messages = useSelector(state => state.signalRMessages?.messages);
    const token = useSelector(state => state.signalRMessages?.token);
    const user = useSelector((state) => state.auth.user);
    const [lessonId, setLessonId] = useState()
    const [askControl, setAskControl] = useState(false)
    const navigate = useNavigate();
    const baseDispatch = useDispatch()
    const location = useLocation();
    const lessonParticipant = location?.state?.lessonParticipant;
    const [showRobot, setShowRobot] = useState(null);
    const { studyGroupId } = useParams();

    useEffect(() => {
        if (projectData.lessonId)
            getLessonData()
    }, [texts, projectData])

    const getLessonData = async () => {
        if (!projectData.lessonId || projectData.lessonId == "0")
            return;
        let data = {
            id: projectData.lessonId,
            studyGroupId: studyGroupId
        }
        lessonsApi.lessonsFilterPost({ lessonFilter: data }, async (error, resdata, response) => {
            if (error) {
                let txt = texts.lessonsFilterError;
                dispatch(throwApiError({ userMessage: txt, error: error, statusCode: response?.statusCode, message: "lessonsFilterPost " + error.message, level: 2, component: "LessonViewer", line: 23 }))
            }
            else {
                let metaDataJson
                if (response?.body?.materialContentPath && response?.body?.materialContentType == 'SLC') {
                    let notCacheNumber = Math.floor(new Date().getTime());
                    const metaData = await fetch(`${response?.body?.materialContentPath}/meta.json${`?notCacheNumber=${notCacheNumber}`}`);
                    if (metaData.ok) {
                        metaDataJson = await metaData.json();
                    }
                }

                if ((response?.body?.materialContentType === 'SLC' && !metaDataJson?.contents?.length) || (response?.body && !(response?.body.materialContentPath && response?.body.materialContentType && response?.body.materialContentType !== "Pdf")))
                    setShowRobot(false);
                else
                    setShowRobot(true)
            }
        })
    }

    const showProjectsPopup = () => {
        setShowProjectActionPopup((prevShowPopup) => !prevShowPopup)
    }

    const closePopup = () => {
        setShowProjectActionPopup(false);
    }

    useEffect(() => {
        if (uiData && uiData.BlockingTeamwork) {
            if (sentRequest && askControl) {
                timeoutRef.current = setTimeout(() => {
                    if (timeoutRef.current && timeoutRef.current !== null) {
                        sendControlRequest(token, ControlRequestTypeEnum.GiveControl, messages[messages?.length - 1]?.userFrom, lessonId, user, studyGroupId,
                            setMessage,
                            <DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.editTaskConfirmationReceived} showCancel={false} confirmText={texts.ok}
                                confirmFunc={() => {
                                    setMessage(null);
                                    baseDispatch(updateReadenMessage(true));
                                }} />,
                            messages, baseDispatch
                        );
                        getProjectData();
                    }
                }, 10000);
            }
        }
    }, [sentRequest, askControl, uiData, applicationId, lang]);

    useEffect(() => {
        clearTimeout(timeoutRef.current);
    }, [messages]);

    useEffect(() => {
        return () => {
            if (iframeRef.current)
                iframeRef.current.href = "about:blank"
        }
    }, [])

    useEffect(() => {
        getProjectData()
    }, [lang, applicationId])

    useEffect(() => {
        if (uiData && uiData.BlockingTeamwork) {
            setMessage(null);
            const lastMessage = messages[messages?.length - 1];
            switch (lastMessage?.message) {
                case ControlRequestTypeEnum.SendControlRequest:
                    if (!lastMessage?.isRead) {
                        setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.teamMemberEditRequestConfirmation} cancelText={texts.reject}
                            cancelFunc={() => {
                                baseDispatch(updateReadenMessage(true))
                                baseDispatch(updateMessageProperty(false));
                                sendMessageToTeam(token, ControlRequestTypeEnum.Reject, lastMessage?.userFrom, null, user, null, setMessage, null);
                            }}
                            confirmText={texts.giveControl}
                            confirmFunc={() => {
                                baseDispatch(updateReadenMessage(true))
                                sendControlRequest(token, ControlRequestTypeEnum.GiveControl, messages[messages?.length - 1]?.userFrom, null, user, null, setMessage, null, messages, baseDispatch);
                                navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                            }} />);
                    }
                    break;
                case ControlRequestTypeEnum.SendControlRequest:
                    if (projectId === messages[messages?.length - 1]?.lessonId && messages[messages?.length - 1]?.givenControl) {
                        navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                    }
                    break;
                case ControlRequestTypeEnum.GiveControl:
                    getProjectData();
                    break;
                case ControlRequestTypeEnum.Reject:
                    if (!lastMessage?.isRead) {
                        setMessage(
                            <DynamicMessage
                                type={DynamicMessageTypeEnum.Warn}
                                title={texts.editTaskConfirmationRejected}
                                showCancel={false}
                                confirmText={texts.ok}
                                confirmFunc={() => {
                                    baseDispatch(updateReadenMessage(true));
                                    setMessage(null);
                                    navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                                }} />);
                    }
                    break;

                case ControlRequestTypeEnum.GetControlRequest:
                    setMessage(
                        <DynamicMessage
                            type={DynamicMessageTypeEnum.Warn}
                            title={texts.sentRequest}
                            showCancel={false}
                            confirmText={texts.cancel}
                            confirmFunc={() => {
                                navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                            }} />);
                    break;
                default:
                    break;
            }
        }
    }, [messages, applicationId, lang]);


    const getProjectData = () => {
        if (lang) {
            let data = {
                id: projectId,
                studyGroupId: studyGroupId
            }
            projectsApi.projectsFilterPost({ projectFilter: data }, (error, resProjectData, response) => {
                if (error) {
                    if (localStorage.getItem("reloadCount") === null) {
                        localStorage.setItem("reloadCount", 0)
                    }
                    if (error?.response?.body?.code == 413) {
                        setLessonId(error?.response?.body?.data?.refObjectId)
                        setMessage(null);
                        startedProject(error?.response?.body?.data?.lockedByUserExternalId, error?.response?.body?.data?.refObjectId)
                    } else
                        if (error.status == 403) {
                            baseDispatch(throwApiError({ userMessage: texts.MessageContentProjectsFilterIdNoPermissions, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 62 }))
                        }
                        else {
                            if (Number(localStorage.getItem("reloadCount")) === 0) {
                                localStorage.setItem("reloadCount", 1)
                                baseDispatch(throwApiError({ userMessage: texts.MessageCantLoad, error: error, statusCode: response?.statusCode, message: "projectsFilterPost " + error.message, level: 3, component: "Project", line: 65, type: "Warn", showCancel: false, showTitle: false, confirmText: texts.reload }))
                            }
                            else {
                                baseDispatch(throwApiError({
                                    userMessage: texts.MessageCantLoad, error: error, statusCode: response?.statusCode, message: "projectsFilterPost " + error.message, level: 2,
                                    component: "Project", line: 65, type: "Warn", showCancel: false, showTitle: false, confirmText: texts.iUnderstand,
                                    showRestore: true
                                }))
                                localStorage.removeItem("reloadCount")
                            }
                        }
                } else {
                    if (resProjectData && applicationId) {
                        const ideConfig = JSON.parse(resProjectData.ide.additionalConfiguration);
                        const ideUrl = resProjectData.ide.url;
                        //this is hard coded to do fix in the future
                        let IdeLang = resProjectData.ide.lang ? resProjectData.ide.lang : lang
                        if (applicationId === "B71AE893-2769-477A-871A-25B077A26D71" && lang === "ar")
                            IdeLang = "ar"
                        const ideId = resProjectData.ide.id
                        setProjectData({
                            assessmentName: resProjectData.name,
                            ideUrl: ideUrl,
                            ideId: ideId,
                            ideLang: IdeLang,
                            ideConfig: ideConfig,
                            lessonId: resProjectData.submission?.lessonId,
                            isShared: response.body.isShared,
                            id: resProjectData.id,
                            name: resProjectData.name,
                            refObjectId: resProjectData.refObjectId,
                            refObjectType: resProjectData.refObjectType,
                            assessmentId: resProjectData.submission?.assessmentId,
                            submissionStatus: resProjectData.submission?.submissionStatus,
                            assessmentActivityType: resProjectData.submission?.assessmentActivityType
                        })
                        projectsApi.projectsHistoryIdPost(projectId, (error, resHistorydata, response) => {
                            if (error) {
                                baseDispatch(throwApiError({ userMessage: texts.MessageContentProjectsHistoryId, error: error, statusCode: response?.statusCode, message: "projectsHistoryIdPost " + error.message, level: 2, component: "Project", line: 76 }))
                            } else {
                                if (resHistorydata.length > 0) {
                                    resHistorydata = resHistorydata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
                                    resHistorydata[0].isCurrent = true;
                                    dispatch({ type: "INIT", versions: resHistorydata })
                                    ideWrapper.load(`${resHistorydata[0].url}`, iframeRef.current, ideUrl, ideConfig, IdeLang, ideId, null, null, resProjectData.id)
                                }
                            }
                        })
                    }
                }
            })
        }
    }

    const saveVersion = (callback, setLoader) => {
        /* after save call to load history */
        ideWrapper.requestSaveProject((file, thumbnail, error) => {
            if ((thumbnail && thumbnail?.name === 'blob') || (thumbnail && thumbnail?.name === undefined)) {
                const blobType = thumbnail?.type;
                const extension = blobType?.split('/')[1];
                const newFileName = `thumbnail.${extension}`;
                thumbnail.name = newFileName;
            }
            const data = {
                id: projectId,
                file: file,
                thumbnail: thumbnail,
                studyGroupId: studyGroupId
            };
            setLoader && setLoader(true)
            projectsApi.projectsSavePost(data, (error, resdata, response) => {
                if (error) {
                    setLoader && setLoader(false)
                    baseDispatch(throwApiError({ userMessage: texts.MessageContentProjectsSavePost, error: error, statusCode: response?.statusCode, message: "projectsSavePost " + error.message, level: 2, component: "Project", line: 109 }))
                    setFinish(false)
                    setTimerMinutes(uiData.lastSave)
                    if (error?.response?.body?.code == 413) {
                        setMessage(<DynamicMessage
                            type={DynamicMessageTypeEnum.Warn}
                            title={texts.LessonInEditByTeamMemberSaveCopy}
                            showCancel={false}
                            confirmText={texts.ok}
                            confirmFunc={() => setMessage(null)} />);
                    }
                }
                else {
                    setLoader && setLoader(false)
                    dispatch({
                        type: "ADD",
                        newVersion: {
                            "id": resdata.id,
                            "url": resdata.url,
                            "createdDate": resdata.createdDate
                        }
                    })
                    callback && callback()
                    setFinish(false)
                    setTimerMinutes(uiData.lastSave)
                    ideWrapper.showToastMesssage("green", "הפרויקט נשמר בהצלחה")
                }
            })
        })
    }

    const loadFunc = (versionId) => {
        let index = versions.findIndex(v => v.id === versionId)
        dispatch({ type: 'SET_CURRENT', id: versionId })
        ideWrapper.load(`${versions[index].url}`, iframeRef.current, projectData.ideUrl, projectData.ideConfig, projectData.ideLang, projectData.ideId)
    }

    const saveCopyVersion = (setLoader) => {
        ideWrapper.requestSaveProject((file, thumbnail, error) => {
            const data = {
                id: projectId,
                file: file,
                refObjectType: ObjectTypeEnumText.StudyGroup,
                refObjectId: studyGroup.id
            }
            setLoader && setLoader(true)
            projectsApi.projectsDuplicatePost(data, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.MessageContentProjectsDuplicatePost, error: error, statusCode: response?.statusCode, message: "projectsDuplicatePost " + error.message, level: 2, component: "Project", line: 140 }))
                    setFinish(false)
                    setTimerMinutes(uiData.lastSave)
                }
                else {
                    ideWrapper.showToastMesssage("green", "הפרויקט נשמר בהצלחה")
                    setFinish(false)
                    setTimerMinutes(uiData.lastSave)
                }
                setLoader && setLoader(false)
            })
        })
    }

    const shareProject = () => {
        let myData = {
            studyGroupId: studyGroupId,
            participantType: ParticipantTypeEnumText.student
        }
        if (studyGroup && !studyGroup.allowSelfRegister) {
            participantsApi.participantsFilterRangePost({ participantsRangeFilter: myData }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.participantsAddError, error: error, statusCode: response?.statusCode, message: "participantsAddPost " + error.message, level: 2, component: "CurriculumPage", line: 36 }))
                }
                else {
                    setSharedProject(true);
                    setFriendsData(response.body);
                }
            })
        }
        else {
            setSharedProject(true);
        }
    }

    const goBack = () => {
        setMessage(null)
        const newPath = state?.prevPath?.replace('/student', '');
        if (projectData.ideId === 1)
            state?.prevPath ? window.location.href = `${state.prevPath}` : window.location.href = `${homeUrl}`;
        else
            newPath ? navigate(`/${newPath}`, { replace: true }) : navigate(homeUrl)
    }

    const saveAndGoBack = () => {
        saveVersion(goBack)
    }

    const goBackConfirm = () => {
        localStorage.removeItem("reloadCount")
        ideWrapper.requestChangesProject((changed) => {
            if (changed == true) {
                setMessage(<DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    title={texts.messageContentSaveProjectContent}
                    cancelFunc={() => setMessage(null)}
                    confirmText={texts.save}
                    confirmFunc={() => saveAndGoBack()}
                    otherText={texts.exitWithoutSaving}
                    otherFunc={goBack}
                    customWidth='430px' />);
            }
            else {
                setMessage(<DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    title={texts.exitIde}
                    cancelFunc={() => setMessage(null)}
                    confirmText={texts.exit}
                    confirmFunc={goBack} />);
            }
        })
    }

    const startedProject = (lockedByUserId, refObjectId) => {
        let myMessage = <DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            title={texts.sentRequest}
            showCancel={false}
            confirmText={texts.cancel}
            confirmFunc={() => { navigate(`${homeUrl}/${studyGroupId}/dashboard`) }} />;

        setMessage(<DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            title={texts.LessonInEditByTeamMember}
            cancelFunc={() => {
                setMessage(null);
                navigate(`${homeUrl}/${studyGroupId}/dashboard`);
            }}
            confirmText={texts.TransferControl}
            confirmFunc={() => {
                setAskControl(true)
                sendMessageToTeam(token, ControlRequestTypeEnum.SendControlRequest, lockedByUserId, refObjectId, user, studyGroupId, setMessage, myMessage);
            }} />);
        setSentReqest(true)
    }

    return (
        <div>
            <Header>
                <div className={`${classes[direction]} ${classes.ProjectsPopupContainer}`}>
                    <div className={classes.ProjectsPopup} onClick={() => showProjectsPopup()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => showProjectsPopup())}>
                        {versions && versions.find(v => v.isCurrent) && versions.find(v => v.isCurrent).createdDate &&
                            <>
                                <img src={projectIcon} className={classes.ProjectIcon} alt="ProjectIcon" />
                                <div className={classes.AssessmentNameWrapper}>
                                    <div className={classes.AssessmentName}>{projectData.assessmentName}</div>
                                    <div className={classes.RecentlySaved} >({texts.recentlySaved} {Moment(versions.find(v => v.isCurrent).createdDate).format('HH:mm DD/MM')})</div>
                                </div></>}
                    </div>
                    <div className={classes.Popup} >
                        {showProjectActionPopup && <ProjectActionPopup versions={versions}
                            saveFunc={(setLoader) => { saveVersion(null, setLoader); setFinish(null) }} saveCopyVersion={(setLoader) => { saveCopyVersion(setLoader); setFinish(null) }} loadFunc={loadFunc}
                            closePopup={closePopup} assessmentName={projectData.assessmentName} setShowProjectActionPopup={setShowProjectActionPopup} />}
                    </div>
                    <div className={classes.SharedContainer} onClick={shareProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, shareProject)}>
                        <p className={classes.SharedText}>{texts.sharedProject}</p>
                        <img src={shareIcon} alt="ShareIcon" />
                    </div>
                    {sharedProject && <PostPopUp fromProjectPage={true} close={() => setSharedProject(null)} project={projectData} beenSharedBefore={beenSharedBefore} setBeenSharedBefore={setBeenSharedBefore} friendsData={friendsData} saveVersion={saveVersion} />}
                    {projectData && <div className={classes.SendContainer} onClick={() => setMessage(<SendLink setMessage={setMessage} project={projectData} saveVersion={saveVersion} />)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setMessage(<SendLink setMessage={setMessage} project={projectData} saveVersion={saveVersion} />))}>
                        <div className={classes.SendText}>{texts.sendProject}</div>
                        <div className={classes.SendIcon}></div>
                    </div>}
                    {
                        (ObjectTypeEnum[projectData.refObjectType] == ObjectTypeEnum.Submission && !hideSubmitProjectBtn &&
                            (projectData.submissionStatus == submissionStatus.notStarted || projectData.submissionStatus == submissionStatus.started || projectData.submissionStatus == submissionStatus.submitted || projectData.submissionStatus == submissionStatus.rejected || projectData.submissionStatus == submissionStatus.resubmitted)) &&
                        <SubmitBtn lessonParticipant={lessonParticipant} submissionId={projectData.refObjectId} assessmentId={projectData.assessmentId} activityType={projectData.assessmentActivityType} studyGroupId={studyGroupId} saveProjectCallback={saveVersion} />
                    }
                </div>
                <div className={`${classes.GoBackBtnProject} ${projectData.ideLang === 'en' ? classes.GoBackBtnProjectEn : ''}`} onClick={goBackConfirm} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, goBackConfirm)}     >
                    <img src={goBbackIcon} className={classes.GoBbackIcon} alt="GoBackIcon" />
                </div>
                <div><SaveTimer initialMinutes={timerMinutes} initialFinish={finish} setFinish={setFinish} initialHours={0} confirmFunc={() => saveVersion()}></SaveTimer></div>
            </Header>
            {projectData.lessonId && showRobot && <Popup lessonId={projectData.lessonId} studyGroupId={studyGroup && studyGroup.id} saveProjectCallback={saveVersion} selectedAssessmentId={projectData.assessmentId} />}{/* assessmentId - need to be the assessment Id (support for assessments array)*/}
            <iframe className={classes.Iframe} frameBorder={0} ref={iframeRef} title='bla'></iframe>
            {message}
        </div>
    )
};

export default Project;